
<template>
    <div class="detail" id="detail">
      <!-- 课程详情 -->
       <app-header v-if="header_show"></app-header>
       <div class="bread_box">
           <div class="bread">
               <span @click="goto('index')">首页</span> <span>></span>
               <span @click="goto('class')">我的课程</span><span>></span>
               <span @click="goto('detail')">{{tagname}}</span><span>></span>
               <span class="last_bread">课程评测</span>
           </div>
       </div>
        <div v-if="step==1" class="info">
           <div class="icon">
             <img src="../assets/images/eval_true.png" alt="">
           </div>
           <p class="title">已完成所有知识点的学习，可以进行课程测评</p>
           <p class="intro">
               <span>答题时长：{{duration/60}}分钟</span>
               <span class="left_space">尝试次数：{{examLimit-limit}}次</span>
               <!-- <span>总分值：{{totalScore}}</span> -->
               <span class="left_space">及格分数：{{pass}}分</span>
            </p>
           <p class="num">剩余尝试次数：<span class="number">{{limit}}</span>次
           <span class="place"> </span>
           最高分：<span class="number">{{maxScore}}</span>分
           <span v-if="maxScore>pass||maxScore==pass" class="status">（已通过）</span></p>
           <div class="go_test">
               <button class="btn" :disabled="limit==0" @click="toTest">开始测评</button>
           </div>

         </div>
        <div class="container" v-if="step == 2">
            <span class="qustion_type">【{{currentQuestion.questionType==0?'单选题':'多选题'}}/{{currentQuestion.points}}分】</span>
            <span class="remain_time">
            <!-- <i class="el-icon-timer"></i> -->
            <img src="../assets/images/achieve_time.png" style="width: 0.3rem;height: 0.3rem;" alt="">
            <span class="remain_time_text">剩余时长：00:{{minutes}}:{{seconds}}</span> </span>
            <div class="question_stem">{{currentQuestion.index}}.{{currentQuestion.Content}}</div>
            <el-radio-group @change="handleChange($event,currentQuestion.questionId)" v-model="currentQuestion.answner">
              <div :key ="index" v-for="(item,index) in currentQuestion.options" >
                <el-radio :label="item.value">{{item.question}}</el-radio>
              </div>
            </el-radio-group>
            <!-- <div :key ="index" v-for="(item,index) in currentQuestion.options">
                <div class="item_question">

                    <el-radio v-model="item.answner" :label="item.questionId">{{item.question}}</el-radio>
                </div>
            </div> -->
            <div class="info_tip">第{{currentQuestion.index}}题 共{{paperTestArr.length}}题</div>
            <div class="operate">
                <button class="btn_next"  :disabled="index<1" @click="upper">上一题</button>
                <button class="btn_sure" @click="handleSubmit" >提交试卷</button>
                <button class="btn_next" :disabled="!(index<paperTestArr.length-1)" @click="next">下一题</button>
            </div>

        </div>

         <div class="masking" v-if="showMask">
          <div class="editmask">
            <div class="edit_top">
              <span>开始测评</span>
              <img @click="closeMasking" src="../assets/images/eval_close.png" alt="">
            </div>
            <div class="content">
                <div class="tip">你有{{duration/60}}分钟时间答题，答题中途无法退出，确认开始答题吗？</div>

            </div>
            <div class="btns">
              <div class="btn_sure" @click="start">开始测评</div>
              <div class="btn_concel" @click="cancel">取消</div>
            </div>
          </div>
         </div>
        <div class="masking" v-if="timeEnd">
            <div class="editmask">
                <div class="edit_top">
                <span>信息</span>
                <img @click="closeMasking" src="../assets/images/eval_close.png" alt="">
                </div>
                <div class="content">
                    <div class="tip">答题时间已用尽，试卷将在{{remainTimeSubmit}} s内自动提交</div>

                </div>
                <div class="btns">
                <div class="btn_sure" @click="handleSubmit">现在提交</div>
                </div>
            </div>
         </div>


    </div>
</template>
<script>
  import Header from '@/components/Header'
  export default {
    name: 'detail',
    components:{
      'app-header':Header,
    },
    data () {
      return {
          header_show:true,
          num: 0,
          totalScore:0,
          pass:0,
          examLimit:0,
          limit:0,
          maxScore:0,
          duration:0,
          showMask: false,
          step:1,
          paperTestArr:[],
          currentQuestion:{},
          item:[],
          index:0,
          select:'',
          answerObj:{},
          answerArr:[],
          remain:0,
          minutes:0,
          seconds :0,
          maxtime:0,
          timeEnd:false,
          remainTimeSubmit:0,
          id:'',
          event:'',
          tagname:'',
          time:false,
          submited:true,
      }
    },
    methods:{
        toTest(){
            this.showMask = true
        },
        getCondition(){
          var _this = this;
            var params = {
                eventId:this.event.eventId,
                courseId:this.id,
            }
            this.post('/course/course/courseQuestionInfo',params,(res)=>{
                const data = res.data
                console.log(data);
                _this.num =data.num
                _this.totalScore = data.totalScore
                _this.duration = data.duration
                _this.maxtime = data.duration
                _this.pass = data.pass
                _this.examLimit = data.examLimit
                _this.limit = data.limit
                _this.maxScore = data.maxScore
            })
        },
        getPaper(){
          var _this = this;
            var params = {
                eventId:this.event.eventId,
                courseId:this.id,
            }
            this.post('/course/course/courseQuestion',params,(res)=>{
                _this.paperTestArr = res.data
                if(_this.paperTestArr.length ==0)return;
                for(let i =0;i<_this.paperTestArr.length;i++){
                    _this.paperTestArr[i].index = i+1
                    _this.paperTestArr[i].value = ''
                    _this.paperTestArr[i].select = ''
                    let tempArr = _this.paperTestArr[i].options.split("@!@").filter(v=>v!=='')
                    for(let j=0;j<tempArr.length;j++){
                        let obj = {}
                        let str = "A"
                        let itemNum = String.fromCharCode(str.charCodeAt()+j);
                        obj.question = itemNum + "：" + tempArr[j];
                        obj.value = itemNum.trim();
                        tempArr[j] = obj;
                        _this.paperTestArr[i].options = tempArr;

                    }
                }
                _this.currentQuestion = _this.paperTestArr[0]
            })
        },
        closeMasking(){
            this.showMask = false
        },
        start(){
		    this.index=0
            this.answerObj={}
            this.answerArr=[]
            this.paperTestArr=[]
            this.currentQuestion={}
            this.getPaper()
            this.showMask = false
            this.submited = false
            this.step = 2
            this.timer(this.maxtime);
        },
        cancel(){
            this.showMask = false
        },
        upper(){
            if(this.index>-1){
              this.currentQuestion = this.paperTestArr[--this.index]
            }
        },
        next(){
            this.select = ''
            this.currentQuestion = this.paperTestArr[++this.index]
        },
        handleSubmit(){
          var _this = this;
            for(let item in this.answerObj){
                let obj = {}
                obj.questionId = item
                obj.answner = this.answerObj[item]
                this.answerArr.push(obj)
            }
            let params = {
                eventId:this.event.eventId,
                courseId:this.id,
                data:this.answerArr
            }
            _this.timeEnd = false;
            this.post('/course/course/submitExam',params,(data)=>{
                this.$mResToast({
                    type:data.status == 200 ? 'success' : 'error',
                    msg:data.msg,
                    duration:3000,
                    isIcon:true,
                });
                _this.submited = true;
                _this.getCondition()
                _this.$nextTick(()=>{
                  _this.step = 1
                })
            })
        },
        handleChange(value,id){
            this.answerObj[id] = value
        },
        timer(){
          var _this = this;
          // console.log(_this.duration);
          // console.log(_this.submited);
          if(_this.submited){
            return false;
          }
          if(_this.duration > 0){
            _this.duration --;
            if(!_this.timeEnd){
              _this.minutes = Math.floor(_this.duration / 60)>9?Math.floor(_this.duration / 60):('0'+Math.floor(_this.duration / 60));
              _this.seconds = Math.floor(_this.duration % 60)>9?Math.floor(_this.duration % 60):('0'+Math.floor(_this.duration % 60));
            }else{
              _this.remainTimeSubmit = _this.duration;
            }
            setTimeout(function(){
              if(_this.$route.path == '/Test'){
                _this.timer(_this.duration);
              }
            },1000)
          }else{
            if(!_this.timeEnd){
              _this.timeEnd = true;
               _this.duration = 10;
               _this.remainTimeSubmit = 10;
              _this.timer(_this.duration);
            }else{
              if(_this.duration > 0){
                _this.timer(_this.duration);
              }else{
                _this.handleSubmit();
                _this.submited = true;
              }
            }

          }
        },
        goto(type){
            if(type=='index'){
                this.$router.push({name:'Course'})
            }else if(type == 'detail'){
               this.$router.go(-1);
                // this.$router.push({name:'Detail',query:{id:this.id}})
            }else if(type == 'class'){
                this.$router.push({name:'Course'})
            }
        }
    },
    mounted(){
        this.event = JSON.parse(localStorage.getItem('event'));
        this.id = this.$route.query.id
        this.tagname = this.$route.query.tagName
        this.getCondition()
    }
  }
</script>
<style scoped>
  .detail{
    min-height: 800px;
  }
.bread_box{
    width: 15rem;
    margin:0 auto;
    margin-top:20px;
}
.bread {
    display:flex;
}
.bread span{
    font-size:0.25rem;
    margin-right:5px;
    cursor: pointer;
}
.last_bread{
    color:#2b73cc;
}
.info{
    width: 15rem;
    margin: 0 auto;
    padding-bottom: 0.84rem;

}
.icon{
  width: 1.35rem;
  height: 1.35rem;
  margin: 01rem auto 0.5rem auto;
}
.icon img{
  width: 100%;
  height: 100%;
  float: left;
}
p{
  text-align: center;
}
.title{
  font-size: 0.42rem;
  color: #404040;
  margin-bottom: 0.27rem;
}
.intro{
  font-size: 0.25rem;
  color: #838383;
  margin-bottom: 0.7rem;
}

.num{
  font-size: 0.35rem;
  color: #404040;
  margin-bottom: 0.7rem;
}
.num .nmber{
  font-size: 0.42rem;
}
.num .status{
  color: #00cf05;
}
.num .place{
  margin-left: 1rem;
}
.btn{
  width: 2.52rem;
  height: 0.83rem;
  margin: 0 auto;
  background-color: #0073d3;
  color: #fff;
  font-size: 0.34rem;
  text-align: center;
  line-height: 0.84rem;
  /* cursor: pointer; */
  border: 1px solid #0073d3;
}
.go_test{
    text-align: center;
}
.left_space{
    margin-left:15px;
}
.masking{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0,0,0,0.65);
}
.masking .editmask{
  width: 7.86rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  background-color: #fff;
  border-radius: 0.1rem;
}
.masking .editmask{
  width: 7.86rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  background-color: #fff;
  border-radius: 0.1rem;
}
.masking .editmask .edit_top{
  width: 7.3rem;
  height: 1.1rem;
  margin: 0 auto;
  border-bottom: 0.01rem solid #767676;
}
.masking .editmask .edit_top span{
  font-size: 0.33rem;
  line-height: 1.1rem;
  color: #000;
  float: left;
  margin-left: 0.3rem;
}
.masking .editmask .edit_top img{
  float: right;
  width: 0.37rem;
  height: 0.35rem;
  margin-top: 0.4rem;
  cursor: pointer;
}
.masking .content {
    height: 100px;
    /* text-align: center; */
    /* margin-left:0.5rem; */
    width:7.3rem;
    margin:0 auto;
    padding-left:0.3rem;
    border-bottom: 0.01rem solid #767676;
}
.masking .tip{
    font-size: 14px;
    line-height: 100px;

}
.masking .editmask .btns{
  width: 7.3rem;
  height: 0.6rem;
  margin: 0.25rem auto 0.34rem auto;
}
.masking .editmask .btns .btn_concel{
  float: right;
  font-size: 0.24rem;
  color: #fff;
  width: 1.38rem;
  height: 0.59rem;
  background-color: #b4b4b4;
  text-align: center;
  line-height: 0.59rem;
  margin-right: 0.31rem;
  cursor: pointer;
}
.masking .editmask .btns .btn_sure{
  float: right;
  font-size: 0.24rem;
  color: #fff;
  width: 1.38rem;
  height: 0.59rem;
  background-color: #2b73cc;
  text-align: center;
  line-height: 0.59rem;
  cursor: pointer;
}
.item_question{
    font-size:0.25rem;
    margin-bottom:20px;

}
.item_question >>> .el-radio__label {
    color:#333;
    font-size: 0.25rem;
}
 >>> .el-radio__label {
    color:#333;
    font-size: 0.25rem;
}
.question_stem{
    font-size:0.25rem;
    margin-bottom: 30px;
    margin-top: 20px;
}
.qustion_type{
    font-size:0.25rem;
    margin-top:40px;
}
.container{
    display: flex;
    flex-direction: column;
    width: 15rem;
    margin: 0 auto;
    position: relative;
}
 .btn_next{
  float: right;
  font-size: 0.24rem;
  color: #fff;
  width: 1.38rem;
  height: 0.59rem;
  background-color: #b4b4b4;
  text-align: center;
  line-height: 0.59rem;
  margin-right: 0.31rem;
  cursor: pointer;
  color: #2b73cc;
    background-color: #fff;
    border: 1px solid #2b73cc;
}
.btn_sure{
  float: right;
  font-size: 0.24rem;
  color: #fff;
  width: 1.38rem;
  height: 0.59rem;
  background-color: #2b73cc;
  text-align: center;
  line-height: 0.59rem;
  cursor: pointer;
  border:1px solid #2b73cc;
}
.operate{
    width: 10rem;
    margin:0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top:20px;
}
.info_tip {
    text-align: center;
    font-size: 0.25rem;
}
.remain_time{
    width:4rem;
    font-size: 0.25rem;
    float: right;
    position: absolute;
    right:0px;
    display: flex;
    align-items: center;

}
.el-icon-timer {
    font-size:30px;
}
.remain_time_text {
    line-height: 30px;
    padding-left: 5px;
}

button[disabled] {
  color: white !important;
  background: #666 !important;
  border: 1px solid #666;
  cursor: no-drop;
}
</style>
<style>
.el-radio-group {
    font-size: 0;
    display: flex;
    flex-direction: column;
}
.el-radio {
    line-height: 30px;
    color: #333;
    display: block;
    margin: 0.1rem 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Test.vue